import { useState } from "react"
import { Link } from "react-router-dom"

import Button from "components/ui/button"
import Checkbox from "components/ui/checkbox"
import Image from "components/ui/image"

const FORM_URL = "https://forms.gle/bEWM2RNp3zew5L959"

const Partnerships = () => {
  const [acceptedTerms, setAcceptedTerms] = useState(false)

  return (
    <>
      {/* <Picture
        alt="Safyre Labs brands"
        fallback={require("images/info/partnerships/safyre-labs-brands-desktop.jpg")}
        srcSet={[
          {
            height: "62",
            media: "(max-width: 767px)",
            sizes: "100vw",
            srcSet: `${require("images/info/partnerships/safyre-labs-brands-mobile.jpg")} 375w, ${require("images/info/partnerships/safyre-labs-brands-mobile_2x.jpg")} 750w`,
            width: "375",
          },
          {
            height: "239",
            media: "(min-width: 768px)",
            sizes: "100vw",
            srcSet: `${require("images/info/partnerships/safyre-labs-brands-desktop.jpg")} 1440w, ${require("images/info/partnerships/safyre-labs-brands-desktop_2x.jpg")} 2880w`,
            width: "1440",
          },
        ]}
      /> */}
      <div className="contained px-32 pb-64 text-center">
        <h1 className="text-38 leading-42 mb-16 mt-48 font-bold">
          Partnerships
        </h1>
        <p className="text-16 leading-20 mb-48 font-medium tracking-tight">
          We believe in authentic, long-lasting, mutually beneficial
          relationships with creators and brands and are always looking for new
          partners to work with. If you are interested in a potential
          partnership, we would love to hear from you!
        </p>
        <Checkbox
          checked={acceptedTerms}
          className="shrink-0 gap-10"
          onChange={() => setAcceptedTerms(!acceptedTerms)}
          value={acceptedTerms}
        >
          <p className="text-16 leading-20 text-left font-medium tracking-tight">
            I accept and agree to the{" "}
            <Button asChild text underline>
              <Link
                data-lc="partnetships"
                target="_blank"
                to="/info/privacy-policy"
              >
                Privacy Policy
              </Link>
            </Button>{" "}
            and{" "}
            <Button asChild text underline>
              <Link
                data-lc="partnetships"
                target="_blank"
                to="/info/terms-conditions"
              >
                Terms and Conditions
              </Link>
            </Button>
          </p>
        </Checkbox>
        <Button
          className="mt-30 mx-auto mb-80 block rounded-sm"
          disabled={!acceptedTerms}
          onClick={() => window.open(FORM_URL, "_blank")}
          variant="secondary"
        >
          Get Started
        </Button>
        <Image
          alt={sl.config.site_title}
          height="30"
          src={require("images/logo/safyre_labs.svg")}
          width="225"
        />
      </div>
    </>
  )
}

export default Partnerships
